<div *ngIf="previewData">
    <h5 class="text-primary fw-semibold mb-1">{{previewData.displayName}}</h5>
    <div>
        <strong>Enquiry No.:&nbsp;</strong> <span class="fw-semibold">{{previewData.enquiryId}} </span>
    </div>
    <div>
        <strong>Document Date:&nbsp;</strong> <span class="fw-semibold">{{previewData.docDate}}</span>
    </div>
    <div>
        <strong>Customer Type:&nbsp;</strong> <span
            class="fw-semibold">{{previewData.customerDetails.customerType}}</span>
    </div>
    <div>
        <strong>Customer Name:&nbsp;</strong> <span class="fw-semibold">{{previewData.customerDetails.name}}</span>
    </div>
    <div>
        <strong>Contact Person:&nbsp;</strong> <span
            class="fw-semibold">{{previewData.customerDetails.contactPerson.name}}</span>
    </div>
    <div>
        <strong>Contact Number:&nbsp;</strong> <span
            class="fw-semibold">{{previewData.customerDetails.contactPerson.mobile}}</span>
    </div>
    <div>
        <strong>Email:&nbsp;</strong> <span
            class="fw-semibold">{{previewData.customerDetails.contactPerson.email}}</span>
    </div>
    <div>
        <strong>Status:&nbsp;</strong> <span class="fw-semibold">{{previewData.status}}</span>
    </div>
</div>